class HeaderPrimary {
  private headerElement: HTMLElement | null;


  // Mobile Nav
  private mobileButton?: HTMLButtonElement | null;
  private mobileNav?: HTMLElement | null;
  private isResizeTicking: boolean = false;
  private isMobileNavEnabled: boolean = false;
  private _boundToggleMobileNav: () => void;
  private readonly mobileBreakpoint: number = 1025;

  constructor() {
    // Bind des méthodes
    this._boundToggleMobileNav = this._toggleMobileNav.bind(this);

    this.headerElement = document.querySelector('header');
    if (!this.headerElement) return;

    this.mobileButton = this.headerElement.querySelector('[data-header-button]');
    this.mobileNav = this.headerElement.querySelector('[data-header-nav]');

    this._handleResize();
    window.addEventListener('resize', () => this._onResize());
  }

  // ===================================================================
  // Gestionnaires de Resize / Scroll
  // ===================================================================

  private _onResize(): void {
    if (!this.isResizeTicking) {
      window.requestAnimationFrame(() => {
        this._handleResize();
        this.isResizeTicking = false;
      });
      this.isResizeTicking = true;
    }
  }

  private _handleResize(): void {
    const isDesktop = window.innerWidth > this.mobileBreakpoint;

    // Logique Mobile Nav (Mobile)
    if (!isDesktop && !this.isMobileNavEnabled) {
      this._initMobileNav();
      this.isMobileNavEnabled = true;
      this.mobileNav?.setAttribute('aria-hidden', 'true')
    } else if (isDesktop && this.isMobileNavEnabled) {
      this._destroyMobileNav();
      this.isMobileNavEnabled = false;
      this.mobileNav?.removeAttribute('aria-hidden');
    }
  }


  // ===================================================================
  // Mobile Nav  
  // ===================================================================

  /**
   * Attache les listeners au bouton mobile et à l'overlay.
   */
  private _initMobileNav(): void {
    if (!this.mobileButton || !this.mobileNav) return;

    this.mobileButton.addEventListener('click', this._boundToggleMobileNav);
  }

  /**
   * Supprime les listeners et nettoie les classes 'active'.
   */
  private _destroyMobileNav(): void {
    if (!this.mobileButton) return;

    this.mobileButton.removeEventListener('click', this._boundToggleMobileNav);

    // Nettoyage des classes
    this._closeMobileNav();
  }

  /**
   * (Appelé par le bouton) Ajoute ou supprime la classe 'active' sur tous les éléments.
   */
  private _toggleMobileNav(): void {
    const isCurrentlyExpanded = this.mobileButton?.getAttribute('aria-expanded') === 'true';
    const newExpandedState = !isCurrentlyExpanded;

    const closeLabel = 'Fermer le menu';
    const openLabel = 'Ouvrir le menu';
    this.mobileButton?.setAttribute('aria-label', newExpandedState ? closeLabel : openLabel);

    this.mobileButton?.setAttribute('aria-expanded', String(newExpandedState));
    if (newExpandedState) {
      this.mobileNav?.removeAttribute('aria-hidden');
    } else {
      this.mobileNav?.setAttribute('aria-hidden', 'true');
    }
    this.mobileButton?.classList.toggle('active', newExpandedState);
    this.mobileNav?.classList.toggle('active', newExpandedState);
    // document.querySelector('body')?.classList.toggle('unscrollable', newExpandedState);
  }

  /**
   * (Appelé par l'overlay ou destroy) Force la fermeture du menu.
   */
  private _closeMobileNav(): void {
    this.mobileButton?.setAttribute('aria-expanded', 'false');
    this.mobileNav?.setAttribute('aria-hidden', 'true')
    this.mobileButton?.classList.remove('active');
    this.mobileNav?.classList.remove('active');
    //  document.querySelector('body')?.classList.remove('unscrollable');
  }
}

export const header = new HeaderPrimary();